export type TaskTypeCategory =
  | 'delivery'
  | 'creative'
  | 'dif'
  | 'qa'
  | 'experiment'
  | 'launch'
  | 'recon'
  | 'brief'
  | 'setup'
  | 'proposal'
  | 'book';

export type TaskTypeMeta = {
  category: TaskTypeCategory;
  /** Used in the prioritizer prompt for category descriptions. */
  description: string;
  hex: { bg: string; text: string };
};

export const TASK_TYPES: Record<TaskTypeCategory, TaskTypeMeta> = {
  delivery: {
    category: 'delivery',
    description: 'pacing recovery, margin protection, velocity intervention, late-flight rescue',
    hex: { bg: '#fee2e2', text: '#b91c1c' }
  },
  creative: {
    category: 'creative',
    description: 'creative review, asset request, rejection follow-up',
    hex: { bg: '#fef3c7', text: '#92400e' }
  },
  dif: {
    category: 'dif',
    description: 'discovery-in-flight tapering, mid-flight strategy change sign-off',
    hex: { bg: '#fed7aa', text: '#c2410c' }
  },
  qa: {
    category: 'qa',
    description: 'pixel QA, tag verification, audit, launch QA',
    hex: { bg: '#e0e7ff', text: '#4338ca' }
  },
  experiment: {
    category: 'experiment',
    description: 'experiment brief, results review, optimization decisions',
    hex: { bg: '#ddd6fe', text: '#5b21b6' }
  },
  launch: {
    category: 'launch',
    description: 'launch prep, approval to launch, go-live confirmation',
    hex: { bg: '#d1fae5', text: '#065f46' }
  },
  recon: {
    category: 'recon',
    description: 'invoice reconciliation, billing variance investigation',
    hex: { bg: '#cffafe', text: '#155e75' }
  },
  brief: {
    category: 'brief',
    description: 'call prep, client briefing, talking-points doc',
    hex: { bg: '#fce7f3', text: '#9d174d' }
  },
  setup: {
    category: 'setup',
    description: 'targeting build, pixel/tag setup, platform setup',
    hex: { bg: '#fef9c3', text: '#854d0e' }
  },
  proposal: {
    category: 'proposal',
    description: 'proposal drafting, mix building, RFP response',
    hex: { bg: '#e0f2fe', text: '#075985' }
  },
  book: {
    category: 'book',
    description: 'IO verification, booking the campaign, contract sign-off',
    hex: { bg: '#ecfccb', text: '#3f6212' }
  }
};

export const TASK_TYPE_CATEGORIES: TaskTypeCategory[] = Object.keys(
  TASK_TYPES
) as TaskTypeCategory[];

export type WrkthruTaskType = {
  category: TaskTypeCategory;
  /** Rendered on the tag, e.g. "Pixel QA". */
  label: string;
};
